import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
export var StreamsCache = /*#__PURE__*/function () {
  function StreamsCache(streams) {
    _classCallCheck(this, StreamsCache);
    this.streams = streams;
  }
  return _createClass(StreamsCache, [{
    key: "has",
    value: function has(id) {
      return !!this.streams.find(id);
    }
  }, {
    key: "set",
    value: function set(id, stream) {
      this.streams.set(id, stream);
    }
  }, {
    key: "get",
    value: function get(id) {
      return this.streams.get(id);
    }
  }, {
    key: "getOrInsert",
    value: function getOrInsert(id, callback) {
      if (!this.has(id)) {
        this.set(id, callback());
      }
      return this.get(id);
    }
  }, {
    key: "removeAll",
    value: function removeAll() {
      this.streams.clear();
    }
  }, {
    key: "remove",
    value: function remove(id) {
      this.streams.delete(id);
    }
  }, {
    key: "size",
    get: function get() {
      return this.streams.size;
    }
  }]);
}();
var streamCache;
export var getFileStreamsCache = function getFileStreamsCache() {
  if (!streamCache) {
    // TODO: we can move this into a static import like
    // import {mediaState} from '@atlaskit/media-core'
    var mediaState = require('@atlaskit/media-core').mediaState;
    streamCache = new StreamsCache(mediaState.streams);
  }
  return streamCache;
};